export default "__VITE_ASSET__c4b0a13e__"